import { NgxIndexedDBService } from 'ngx-indexed-db';
import { forkJoin, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export interface AnimalIdRemap {
    localAnimalId: string;
    returnedAnimalId: string;
    returnedAnimal: any;
}

export interface AnimalIdReconcilable {
    reconcileAnimalId(remap: AnimalIdRemap): Observable<void>;
}

export function replaceAnimalId(value: any, remap: AnimalIdRemap): any {
    if (value === remap.localAnimalId) return remap.returnedAnimalId;
    if (Array.isArray(value)) return value.map((item) => replaceAnimalId(item, remap));
    if (value?.constructor === Object) {
        return Object.keys(value).reduce((result: any, key) => {
            result[key] = replaceAnimalId(value[key], remap);
            return result;
        }, {});
    }
    return value;
}

export function reconcileAnimalReferences(
    dbService: NgxIndexedDBService,
    storeName: string,
    indexes: string[],
    remap: AnimalIdRemap
): Observable<void> {
    return forkJoin(
        indexes.map((index) =>
            dbService.getAllByIndex<any>(storeName, index, IDBKeyRange.only(remap.localAnimalId))
        )
    ).pipe(
        map((results) => ([] as any[]).concat(...results).map((record) => replaceAnimalId(record, remap))),
        switchMap((records) =>
            records.length ? dbService.bulkPut(storeName, records) : of(undefined)
        ),
        map(() => undefined)
    );
}
